const Context = {
    Player: 0,
    Screen: 1
  }
  
  const Commands = {
    MoveUp: { context: Context.Player, action: "Move", x: 0, y: -1 },
    MoveDown: { context: Context.Player, action: "Move", x: 0, y: 1 },
    MoveLeft: { context: Context.Player, action: "Move", x: -1, y: 0 },
    MoveRight: { context: Context.Player, action: "Move", x: 1, y: 0 },
    Rest: { context: Context.Player, action: "Rest" },
    Equip: { context: Context.Screen, action: "Equip" },
    Help: { context: Context.Screen, action: "Help" },
    Look: { action: "Look" },
    Target: { action: "Target" },
    Get: { action: "Get", context: Context.Player },
    Drop: { action: "Drop", context: Context.Player },
    Open: { action: "Open", context: Context.Player },
    Close: { action: "Close", context: Context.Player },
    Examine: { action: "Examine", context: Context.Screen },
    Pause: { action: "Pause", context: Context.Screen },
    RangedAttack: { action: "RangedAttack", context: Context.Player },
    ShowStory: { context: Context.Screen, action: "ShowStory", character: "Toothrot" },
    HideStory: { context: Context.Screen, action: "HideStory" },
    EquipWeapon: { context: Context.Player, action: "EquipWeapon" },
    ShowLog: { context: Context.Screen, action: "ShowLog" },
    ShowDebug: { context: Context.Screen, action: "ShowDebug" },
    StartGame: { context: Context.Screen, action: "StartGame" },
    ShowControls: { context: Context.Screen, action: "ShowControls" },
    ShowCredits: { context: Context.Screen, action: "ShowCredits" },
    HideDialog: { context: Context.Screen, action: "HideDialog" },
    QuitGame: { context: Context.Screen, action: "QuitGame" }
  }
  
  export {
    Context,
    Commands
  }
  